import { AlertTriangle, Info, OctagonAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useSession } from '@/auth/session';
import { cn } from '@/lib/utils';

const TONE_STYLES = {
  info: { bg: 'bg-cyan-500/10 text-cyan-800 border-cyan-500/30', Icon: Info },
  warning: { bg: 'bg-gold-500/10 text-gold-700 border-gold-500/30', Icon: AlertTriangle },
  danger: { bg: 'bg-status-expired/15 text-status-expired border-status-expired/40', Icon: OctagonAlert },
} as const;

/** Renewal nag from /auth/me. Silent when there's nothing to say. */
export function SubscriptionBanner() {
  const { banner, isSuperadmin } = useSession();

  if (isSuperadmin || !banner) return null;

  const tone = TONE_STYLES[banner.tone as keyof typeof TONE_STYLES] ?? TONE_STYLES.info;
  const { Icon } = tone;

  return (
    <div className={cn('flex items-center gap-3 border-b px-4 py-2 text-sm', tone.bg)}>
      <Icon className="h-4 w-4 shrink-0" />
      <p className="flex-1">{banner.text}</p>
      <Link to="/subscription" className="shrink-0 font-semibold underline underline-offset-2">
        Renew now
      </Link>
    </div>
  );
}
